import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const UserMenuOptionRoot = styled(Col)(
    ({ theme }) => css`
        padding: ${theme.spacing.all(1, 5)};
        .LabelRoot {
            row-gap: 0;
            label {
                color: ${theme.palette.overlays[0][60]};
            }
            .LabelChildren {
                .Typography {
                    color: ${theme.palette.secondary};
                    margin-top: -${theme.spacing["1"]};
                }
            }
        }
    `,
);
